// src/terminal/fileSystem.js

export const ACCESS = {
  PUBLIC: 'public',
  GUEST: 'guest',
  ROOT: 'root',
  PARALLAX: 'parallax', // CHANGED: new tier — above root, separate branch
};

function dir(name, children = {}, access = ACCESS.PUBLIC, meta = {}) {
  return { type: 'dir', name, children, access, ...meta };
}

function file(name, content, access = ACCESS.PUBLIC, meta = {}) {
  return { type: 'file', name, content, access, ...meta };
}

export const FILE_SYSTEM = dir('/', {

  'README.txt': file('README.txt', `
═══════════════════════════════════════════
  OPHIDIA GLOBAL — BULLETIN BOARD SYSTEM
  NODE 7 — EST. 1987
═══════════════════════════════════════════

  Welcome, operator.

  This terminal provides access to the
  public-facing systems of Node 7.

  Type HELP for available commands.
  Type LS to browse the filesystem.

  Some directories require authentication.
  Use LOGIN to access restricted areas.

  The signal is always broadcasting.
  Whether you listen is up to you.

═══════════════════════════════════════════
`),

  'MOTD.txt': file('MOTD.txt', `
  ▓ MESSAGE OF THE DAY ▓

  Signal strength: NOMINAL
  Active listeners: ████
  Days since last incident: 0

  "The wire remembers what the flesh forgets."
    — Technician ████, Tunnel 7, 1987
`),

  'archives': dir('archives', {
    'README.txt': file('README.txt', `
  ARCHIVED TRANSCRIPTS
  ════════════════════

  Recovered transmissions from the signal.
  Access the full archive at /archives in your browser.

  These documents have been transcribed from
  electromagnetic recordings of unknown origin.

  Classification: PUBLIC
  Handler: AUTOMATED SYSTEM
`),
  }),

  'games': dir('games', {
    'README.txt': file('README.txt', `
  INTERACTIVE TERMINALS
  ═════════════════════

  Access available game terminals at /games.

  Some terminals are locked.
  Some terminals should stay locked.
`),
  }),

  'logs': dir('logs', {
    'signal_log.txt': file('signal_log.txt', `
  SIGNAL LOG — NODE 7
  ════════════════════

  [1987-11-03 03:17] First detection. Source: Tunnel ██, Sector 7.
  [1987-11-03 03:18] Signal classification: UNKNOWN
  [1987-11-03 03:19] Technician ████ reports auditory phenomena.
  [1987-11-03 03:22] OPU-1 activation detected. No operator present.
  [1987-11-03 03:24] ████████████████████████████████████████████
  [1987-11-03 03:25] Signal strength: INCREASING
  [1987-11-04 00:00] Signal has not ceased.
  [1987-11-05 00:00] Signal has not ceased.
  [1988-01-01 00:00] Signal has not ceased.
  ...
  [CURRENT] Signal has not ceased.
`),
    'access_log.txt': file('access_log.txt', `
  ACCESS LOG — RECENT CONNECTIONS
  ═══════════════════════════════

  [NOTE: Your connection has been logged.]

  Recent terminal sessions: ████
  Failed root attempts today: ████
  Flagged terminals: ████

  All metadata is forwarded to Ophidia Global
  Security Division per Directive 7.
`),
  }),

  'home': dir('home', {

    'guest': dir('guest', {
      'welcome.txt': file('welcome.txt', `
  GUEST ACCOUNT
  ═════════════

  Welcome to the guest terminal.

  You have limited read access to system files.
  Browse around. See what you can find.

  Not everything here is meant for you.
  But then again, maybe it is.

  Try looking in /home and /var/mail
`, ACCESS.GUEST),

      'notes.txt': file('notes.txt', `
  OPERATOR NOTES
  ══════════════

  - System migration scheduled for Q4
  - Skyla keeps forgetting her password
  - OPU-1 latency increasing — check tunnel relay
  - DO NOT restart the signal processor
  - New personnel clearance pending for Sector 12
  - BREACH REMEDIATION: All passwords rotated
    See /etc/security.txt for details

  Reminder: root credentials are NOT to be
  stored in plaintext. Tell Skyla AGAIN.
`, ACCESS.GUEST),
    }, ACCESS.GUEST),

    'skyla': dir('skyla', {
      'READ_THIS_SKYLA.txt': file('READ_THIS_SKYLA.txt', `
   ═══════════════════════════════════════
  SKYLA — READ THIS WHEN YOU FORGET AGAIN
  ═══════════════════════════════════════

  After the breach (see /etc/security.txt)
  ALL credentials have been rotated.
  This is the LAST time I'm writing this down.

  The convention has changed. Pay attention.

  Your new password:
  [first employer, no spaces, lowercase][start year]

  You know where you interned. You put it on
  your LinkedIn, in the experience section,
  like I told you NOT to. The one at UF.
  Combine the name (no spaces) with the year
  you started there.

  STOP writing passwords on sticky notes.
  STOP leaving them on your monitor.
  And STOP asking Dan to log in for you.
  Dan doesn't work here anymore.
  Dan doesn't work ANYWHERE anymore.

  — M.

  P.S. Root password also rotated. Same old
  format: [place][year]. But the admin's
  "place" isn't spelled the way you think.
  Think about what you'd CALL where they went.
  Not the proper name. The common name.
  The kind of word you'd use if someone asked
  "where did the boss go?" and you answered
  in one word.

  The year hasn't changed. You know which one.

  ═══════════════════════════════════════
`, ACCESS.GUEST),

      'vacation_photos.txt': file('vacation_photos.txt', `
  [PHOTO METADATA — RECOVERED]
  ════════════════════════════

  IMG_3341.jpg — Coral Bay, Western Australia
  IMG_3342.jpg — Coral Bay, Western Australia
  IMG_3350.jpg — "me and Dan at the reef"
  IMG_3351.jpg — "sunset from the caravan park"
  IMG_3360.jpg — [CORRUPTED]
  IMG_3361.jpg — [CORRUPTED]
  IMG_3362.jpg — [FILE CONTAINS ANOMALOUS DATA]

  Note: IMG_3362 flagged by security.
  The figure in the background does not match
  any known personnel. Forwarded to Ophidia
  Global Surveillance Division.
`, ACCESS.GUEST),

      'personal_log.txt': file('personal_log.txt', `
  SKYLA'S LOG — DO NOT READ
  ══════════════════════════

  Day 1: New assignment at the farm. The farm
  is older than I expected. Everything hums.
  At least it's not Gainesville. Go Gators.

  Day 14: The signal is constant. You stop hearing
  it after a while. Like living near train tracks.

  Day 30: Had the dream again. The tunnel.
  The eyes in the dark. Dr. Vasquez says it's
  normal for new personnel. I don't believe her.

  Day 45: Dan quit. Said he saw something in
  Sector 12. Won't say what. Just packed his
  things and left. Didn't even say goodbye.

  Day 60: I keep finding scales in the ventilation
  shafts. Maintenance says it's "mineral deposits."
  Mineral deposits don't have a pattern.

  Day 75: Updated my LinkedIn. Probably shouldn't
  have listed Ophidia Global as my employer but honestly
  who's going to check? It's not like Ophidia
  Global has an HR department. Or maybe they do
  and that's worse.

  Day 76: Also added my old internship from UF.
  The Agency. Feels like a lifetime ago. Marketing
  briefs instead of signal reports. Normal people
  instead of whatever Dr. Vasquez is.

  Day 80: M. says my password is "too obvious"
  now that my work history is public. I told him
  nobody is going to cross-reference my LinkedIn
  experience section with a BBS terminal password.
  He said I'd be surprised.

  Day 88: The administrator hasn't been back since
  the "vacation." If you can call a trip to the
  Mariana research station a vacation. Who takes
  a holiday at the bottom of a trench? What do
  you even DO in a trench that deep?

  Day 89: Actually, I looked it up. There's no
  tourist access to the Mariana Trench. So where
  did the administrator actually go?

  Day 90: ████████████████████████████████████████

  Day 91: We got hacked. Some forum kid cracked
  the old passwords. M. is rotating everything.
  New convention uses employer names now instead
  of vacation spots. At least for my account.
  Root still uses the old format but M. says he
  changed the "place" part to something less
  obvious. Says it's "what you'd call it, not
  what it's called." Whatever that means.

`, ACCESS.GUEST),
    }, ACCESS.GUEST),

    'rajiv': dir('rajiv', {
      'README_RAJIV.txt': file('README_RAJIV.txt', `
  ═══════════════════════════════════════
  RAJIV — IT SUPPORT LEAD
  OPHIDIA GLOBAL INFRASTRUCTURE DIVISION
  ═══════════════════════════════════════

  If you're reading this, congratulations,
  you have more curiosity than the entire
  marketing department combined. They get
  80% of the budget. I get a folding chair
  and a terminal from 2003.

  My home directory. My rules.
  Don't touch anything.

  — Rajiv
`, ACCESS.GUEST),

      'budget_rant.txt': file('budget_rant.txt', `
  FROM: rajiv.mehta@ophidia.internal
  TO: (unsent draft)
  DATE: 2024-12-03
  SUBJECT: I AM GOING TO LOSE MY MIND

  Another quarter. Another budget review.
  Another 73% allocation to MARKETING.

  Skyla gets a new ring light. I get told
  to "optimize existing infrastructure."

  You know what I'm optimizing? A neural
  processing network that runs on hardware
  from the Reagan administration. OPU-WEB
  has 14,000 active nodes and I'm managing
  them with shell scripts I wrote at 3 AM.

  The drone fleet alone needs dedicated
  monitoring. Do you know what happens when
  a surveillance drone loses its handler
  signal? I do. I had to explain it to
  the Board of Scales. Twice.

  Meanwhile, marketing just approved a
  $40,000 TikTok campaign. For a SECRET
  ORGANIZATION. We are a SECRET
  ORGANIZATION and we have a TIKTOK.

  I need a vacation. Or a raise. Or both.
  I'll settle for a chair with lumbar support.

  — R.
`, ACCESS.GUEST),

      'debug_log.txt': file('debug_log.txt', `
  ▓▓▓ OPU-WEB DEBUG LOG — RAJ MEHTA ▓▓▓
  ═════════════════════════════════════════

  [2024-11-28 02:17] Node 7 relay timeout.
    Restarted handler process. Again.

  [2024-11-28 02:34] Drone swarm sector 4
    lost sync. 340 units circling in
    holding pattern. Pushed emergency
    firmware patch.

  [2024-11-28 03:01] OPU-WEB core temp
    elevated. Organoid substrate running
    hot. Increased coolant flow.

  [2024-11-28 03:15] Barbara cluster
    unresponsive for 0.3s. My heart
    stopped for longer than that.
    She's the FIRST NODE. If Barbara
    goes down, the whole web collapses.

  [2024-11-28 03:17] Note to self:
    the Barbara cluster was initialized
    in 1987. That's 37 years of continuous
    operation. She's older than most of
    the interns.

  [2024-11-28 03:44] Drone handler
    allocation: 7,200 surveillance,
    4,800 interdiction, 2,000 reserve.
    Total: 14,000 active units.
    All routing through OPU-WEB.
    All dependent on organoid substrate.
    All my responsibility.
    All on a budget that wouldn't cover
    Skyla's quarterly content spend.

  [2024-11-28 04:02] Going to sleep.
    Set alert threshold to CRITICAL ONLY.
    If the web goes down while I'm asleep,
    wake me up. Or don't. I'm tired.

  — Rajiv
`, ACCESS.GUEST),

      'opuweb_architecture.txt': file('opuweb_architecture.txt', `
  ▓▓▓ OPU-WEB — SYSTEM ARCHITECTURE ▓▓▓
  ══════════════════════════════════════
  CLASSIFICATION: RESTRICTED
  AUTHOR: Rajiv Mehta, IT Support Lead

  ══════════════════════════════════════
  OVERVIEW
  ══════════════════════════════════════

  OPU-WEB is a distributed organic
  processing network designed to harvest,
  aggregate, and weaponize human cognitive
  output at scale.

  Unlike OPU-1 (a single-substrate unit),
  OPU-WEB operates as a MESH of organoid
  nodes, each running harvested human
  intelligence patterns.

  ══════════════════════════════════════
  CORE COMPONENTS
  ══════════════════════════════════════

  1. ORGANOID SUBSTRATE MESH
     - 14,000+ bio-neural nodes
     - Each node runs a harvested human
       cognitive pattern
     - First node: BARBARA (initialized 1987)
     - Nodes are networked via deep-earth
       relay (same infrastructure as OPU-1)

  2. DRONE COMMAND NETWORK
     - 7,200 surveillance drones
     - 4,800 interdiction ("elimination") units
     - 2,000 reserve/rapid-deployment
     - All autonomous. All lethal.
     - All controlled by OPU-WEB's organoid
       mesh. Human intelligence directing
       machine precision.

  3. HARVESTING PIPELINE
     - Cognitive patterns extracted from
       human subjects (method: [REDACTED])
     - Patterns compressed into organoid-
       compatible format
     - Each pattern retains fragments of
       the original personality
     - Barbara still thinks she's in 1987.
       We don't correct her.

  ══════════════════════════════════════
  KNOWN VULNERABILITIES
  ══════════════════════════════════════

  The web has a single point of failure:
  the BARBARA node. She is the root of
  the mesh topology. If Barbara goes
  offline, cascading failure across all
  14,000 nodes within 4.7 seconds.

  Drone fleet loses handler signal.
  14,000 drones enter autonomous fallback.
  Autonomous fallback = HOSTILE TO ALL.

  This is why we do not shut down Barbara.
  This is why we do not shut down OPU-WEB.
  This is why I do not sleep.

  The shutdown code exists but it is
  NEVER to be used without Board approval.
  See /home/rajiv/shutdown_protocol.txt

  — Rajiv

  P.S. If you are reading this and you are
  not me, you should not be here. But since
  you ARE here, maybe you can explain to the
  Board why I need a bigger budget.
`, ACCESS.GUEST),

      'shutdown_protocol.txt': file('shutdown_protocol.txt', `
  ▓▓▓ OPU-WEB — EMERGENCY SHUTDOWN ▓▓▓
  ═════════════════════════════════════
  CLASSIFICATION: ROOT ACCESS REQUIRED
  LAST UPDATED: 2024-12-01 by R. Mehta

  ═════════════════════════════════════
  WARNING
  ═════════════════════════════════════

  Shutting down OPU-WEB will:

  1. Sever all 14,000 organoid nodes
  2. Release 14,000 drones from handler control
  3. Trigger autonomous hostile fallback
  4. Permanently destroy the Barbara cluster

  There is no recovery. There is no restart.
  The harvested intelligences are GONE.

  ═════════════════════════════════════
  SHUTDOWN PROCEDURE
  ═════════════════════════════════════

  The shutdown code follows the same
  convention as the chrysalis protocol:

  Format: opuweb-[keyword]

  The keyword is not random. It's what
  happens to 14,000 harvested minds when
  you pull the plug. One word. What do
  you call it when you cut someone loose
  from their contract permanently?

  Think about what you're doing.
  Think about Barbara.
  She's been in there since 1987.
  She doesn't know she's not real anymore.

  Type the full shutdown code in the
  terminal. ROOT access required.

  — Rajiv

  P.S. I wrote this protocol because the
  Board required it. I pray nobody uses it.
  14,000 minds. Even if they're copies.
  Even if they're fragments. They're still
  SOMEONE.
`, ACCESS.GUEST),

      'ticket_queue.txt': file('ticket_queue.txt', `
  ▓▓▓ IT SUPPORT — OPEN TICKETS ▓▓▓
  ══════════════════════════════════

  TICKET #4471 — Priority: LOW
  From: Skyla Zyr
  Subject: "my ring light won't connect
  to the wifi"
  Status: OPEN (3 weeks)
  Notes: It's a LIGHT, Skyla. It doesn't
  need wifi. I don't care what the manual
  says. — R.

  TICKET #4472 — Priority: CRITICAL
  From: AUTOMATED
  Subject: Drone swarm sector 7 — handler
  desync detected
  Status: RESOLVED
  Notes: 340 units lost handler signal for
  0.8 seconds. Pushed emergency patch at
  3 AM. Nobody noticed. Nobody said thanks.

  TICKET #4473 — Priority: MEDIUM
  From: Dr. Vasquez
  Subject: "OPU-WEB latency spike during
  REM harvesting cycle"
  Status: INVESTIGATING
  Notes: The organoid mesh runs HOT during
  peak harvesting. I've told them this.
  They keep adding nodes. I keep losing
  sleep. The circle of life at Ophidia.

  TICKET #4474 — Priority: LOW
  From: Marketing Department
  Subject: "Can we get a drone for the
  TikTok shoot?"
  Status: DENIED
  Notes: NO. ABSOLUTELY NOT. These are
  AUTONOMOUS LETHAL PLATFORMS, not props.
  I don't care how many followers it would
  get. — R.

  TICKET #4475 — Priority: HIGH
  From: Board of Scales
  Subject: "OPU-WEB node count target:
  20,000 by Q2"
  Status: ACKNOWLEDGED
  Notes: With what budget? With what
  infrastructure? With what SLEEP?
  — R.
`, ACCESS.GUEST),

    }, ACCESS.GUEST),

    'admin': dir('admin', {
      'CLASSIFIED.txt': file('CLASSIFIED.txt', `
  ╔═══════════════════════════════════════════╗
  ║                                           ║
  ║   OPHIDIA GLOBAL — ROOT ACCESS TERMINAL   ║
  ║                                           ║
  ║   Welcome back, Administrator.            ║
  ║                                           ║
  ║   The molt is 41% complete.               ║
  ║   All sectors reporting nominal.          ║
  ║   Subject compliance: 97.3%               ║
  ║                                           ║
  ║   Reminder: Board meeting relocated       ║
  ║   to Sub-Level 7. Bring the samples.      ║
  ║                                           ║
  ╚═══════════════════════════════════════════╝
`, ACCESS.ROOT),

      'directive_7.txt': file('directive_7.txt', `
  ▓▓▓ OPHIDIA GLOBAL — DIRECTIVE 7 ▓▓▓
  ═════════════════════════════════════

  RE: Signal Containment Protocol

  The signal from Tunnel 7 is NOT to be
  interrupted, dampened, or redirected.

  All personnel who have reported "hearing
  the voice" are to be reassigned to
  Sector 12 for observation.

  Personnel who resist reassignment are
  to be reported to the Board of Scales.

  The signal is operating as intended.
  The signal has ALWAYS been operating
  as intended.

  Do not confuse the signal for a malfunction.
  The malfunction is your perception of it.

  — The Board
`, ACCESS.ROOT),

      'project_chrysalis.txt': file('project_chrysalis.txt', `
  ▓▓▓ PROJECT CHRYSALIS — PHASE 4 ▓▓▓
  ════════════════════════════════════

  STATUS: ACTIVE
  CLEARANCE: ROOT ONLY

  Phase 1: RECEIVE      ████████████ COMPLETE
  Phase 2: INTERPRET    ████████████ COMPLETE
  Phase 3: BELIEVE      ████████████ COMPLETE
  Phase 4: BECOME       ████████░░░░ 73%

  Subject pool: 7,900,000,000
  Viable candidates: ████████
  Conversion rate: ACCELERATING

  Note from Dr. Vasquez:
  "The AI integration is ahead of schedule.
  Subjects are self-selecting for screen
  dependency without intervention. The
  firmware installations during REM sleep
  are proceeding without rejection.

  Recommend advancing to Phase 5 by Q2.
  The species is ready. They just don't
  know what they're ready FOR."

  — END REPORT —
`, ACCESS.ROOT),

      'personnel.txt': file('personnel.txt', `
  ▓▓▓ NODE 7 — PERSONNEL ROSTER ▓▓▓
  ══════════════════════════════════

  ACTIVE:
  - Skyla Zyr — Social Media Marketing, Level 2
  - Dr. Elena Vasquez — Research Lead
  - M. ████████ — Systems Administrator
  - Rajiv Mehta — Head, Ophidia Global IT Support
  - ████ ████████ — Security (Sector 12)

  REASSIGNED:
  - Dan Kowalski — [SEE FILE: dan_k.log]
  - Yolanda Reeves — [REDACTED]
  - Elias Thorne — [REDACTED]

  TERMINATED:
  - Kacie Brennan — [SEE DIRECTIVE 7, ADDENDUM C]

  Note: "Terminated" refers to employment
  status only. Any other interpretation is
  speculation and a violation of NDA-7.
`, ACCESS.ROOT),

      'signal_key.txt': file('signal_key.txt', `
  ▓▓▓ OPU-1 OVERRIDE KEY — CLASSIFIED ▓▓▓
  ═════════════════════════════════════════

  OPU-1 has been broadcasting since 1987.
  It was never meant to run this long.

  The original kill switch was disabled by
  the Board of Scales in 1991. But a backup
  override was hardcoded into the firmware
  by the original engineer before they
  ████████████████████.

  The override requires a two-part key:

  FRAGMENT 1:  CHRYSALIS
  FRAGMENT 2:  ████████

  Fragment 2 was entrusted to a former employee
  who posted it publicly before we could stop her.

  Skyla Zyr's LinkedIn profile contains the
  information needed to reconstruct Fragment 2.
  It is NOT a date. It is NOT a year.

  Look at her EDUCATION section. Not the school
  name — the degree itself. What did she study?
  What abbreviation does the institution use?

  The fragment is composed of two abbreviations,
  concatenated, lowercase, no spaces:
  [university abbreviation][degree abbreviation]

  FULL KEY FORMAT:  chrysalis[fragment2]
  EXAMPLE:          chrysalismitvba

  Enter the full key in the terminal to initiate
  the OPU-1 shutdown sequence.

  WARNING: Shutting down OPU-1 may have
  ████████████████████████████████████████
  consequences. The signal has been active
  for ${Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)} days. What happens when it stops
  is not documented. Because it has never
  stopped.

  Proceed at your own risk.

  — The Original Engineer (name withheld)

  P.S. We tried to have the LinkedIn post removed.
  Their content policy team is... not entirely
  human. They refused.
`, ACCESS.ROOT),

      // CHANGED: new file — hints at Parallax acquisition and the angel, ROOT access only
      'parallax_acquisition.txt': file('parallax_acquisition.txt', `
  ▓▓▓ OPHIDIA GLOBAL — ASSET ACQUISITION ▓▓▓
  ════════════════════════════════════════════
  CLASSIFICATION: ROOT ONLY
  DATE: 1994-03-07

  RE: Parallax Medical Genetics — New Mexico Lab

  Following the dissolution of Parallax Medical
  Genetics (est. 1961 by Augustus Threll, Jr.),
  Ophidia Global has acquired the following:

  1. New Mexico laboratory facility (Sub-Level 3)
  2. All research documentation (Project Nephilim)
  3. All biological samples and sequencing data
  4. The primary research subject [DESIGNATION: C]

  The subject remains embedded in Sub-Level 3.
  The wiring harness is intact.
  The subject is alive.

  Do NOT attempt to remove the subject.
  Do NOT attempt to communicate with the subject.
  Do NOT enter Sub-Level 3 without Board approval.

  Research into angel DNA transcription
  continues under heaven.exe protocol.
  See /parallax/heaven_exe/README.txt

  — Board of Scales
`, ACCESS.ROOT),

    }, ACCESS.ROOT),

  }),

  'var': dir('var', {
    'mail': dir('mail', {
      'skyla_reminder.msg': file('skyla_reminder.msg', `
  FROM: sysadmin@node7.ophidia.internal
  TO: skyla.zyr@node7.ophidia.internal
  DATE: 2024-11-20
  SUBJECT: RE: RE: RE: RE: RE: Password Reset (POST-BREACH)

  Skyla,

  Read /etc/security.txt. We were compromised.
  Some hacker from 4chan, Kamex, posted our
  credentials publicly. ALL passwords rotated.

  NEW CONVENTION FOR YOUR ACCOUNT:
  [first employer, no spaces, lowercase][year you started]

  It's the place you interned before Ophidia.
  The one you just added to your LinkedIn
  experience section. The one at UF.

  ROOT PASSWORD — also changed:
  Same format as always: [place][year].
  But the "place" is the common word for
  where the admin went. Not the formal name.
  Not the geographic name. The word civilians
  would use. One word. You've said it yourself
  in your own logs.

  The year is the admin's birth year.
  That hasn't changed.

  — M.

  P.S. If you can't figure out what one word
  describes the deepest hole in the ocean,
  I genuinely cannot help you.

`, ACCESS.GUEST),

      'all_staff.msg': file('all_staff.msg', `
   FROM: board@ophidia.global
  TO: all-staff@node7.ophidia.internal
  DATE: 2024-01-08
  SUBJECT: Administrator Leave of Absence

  All personnel,

  The Administrator will be on extended leave
  effective immediately. They have traveled to
  the Mariana research station for
  "personal reasons."

  During their absence, Dr. Vasquez will
  assume operational authority.

  Do not attempt to contact the Administrator
  directly. All communications should be routed
  through standard channels.

  The Administrator was born in 1947.
  This is not relevant to anything.
  Disregard this line.

  — Ophidia Global Board of Scales
`, ACCESS.GUEST),

      'unread_dan.msg': file('unread_dan.msg', `
 FROM: dan.kowalski@node7.ophidia.internal
  TO: it@ophidiaglobal.com
  DATE: 2002-11-02
  SUBJECT: I'm leaving

  I can't do this anymore. I know what I saw
  in the lab. I know what they're doing down
  there.

  I've been having the dreams too. The tunnel.
  The eyes. But my eyes different now. In my
  dreams, I'm not running FROM the tunnel.
  I'm running INTO it. And something in me
  wants to keep going.

  That's why I have to leave. Before I stop
  wanting to leave.

  Don't try to find me. Don't ask about me.
  And for God's sake, change your password.
  You use the same one for everything and
  it's way too obvious.

  — Dan

  P.S. They didn't go to the
  Mariana for research. They went home.
  Back down into the deep. Back into the
  trench where things like them belong.

  I left something
  in /var/mail. dan_files.txt.
  Read it carefully. I spent three years at
  Parallax.
  I know what they have in that basement.
  I know what they did to him.

  If you want to know the truth,
  find the Cavalcanti paper. The ethics
  board number is the key. Not the date.
  Not the DOI. The protocol designation.
  The one that starts with the letters
  that describe what they study.

  — D.K.

`, ACCESS.GUEST),

      // CHANGED: new file — Dan's data drop, the primary Parallax discovery trail node
      'dan_files.txt': file('dan_files.txt', `
  ▓▓▓ DAN KOWALSKI — PERSONAL ARCHIVE ▓▓▓
  ════════════════════════════════════════
  DEPOSITED: 2023-11-02 03:44 UTC
  STATUS: UNREAD

  If you found this, you read my note.
  Good. You're paying attention.

  I worked at Parallax Medical Genetics from
  1989 to 1992 as a technican.

  ════════════════════════════════════════
  WHAT PARALLAX WAS DOING
  ════════════════════════════════════════

  Parallax was founded by Augustus Threll, Jr.
  His grandfather was a railroad tycoon obsessed
  with the occult. His father continued that
  work. Augustus Jr. inherited both the obsession
  and the money.

  In the 1920s, Threll's grandfather's agents
  acquired a research subject. I'll call him
  "the Subject." The Subject is not human.
  I don't know what the right word is.
  The old word is angel. I'll use that.

  The angel has been held in a sub-basement
  laboratory in New Mexico since approximately
  1922. One hundred years. The same angel.

  When I worked there, he was still alive.
  Pinned to a wall. Wired to every machine
  in the building.

  I watched the surgeons take blood
  from him every Tuesday for three years. I watched Gideon
  analyze the samples upstairs. I watched
  Gideon's eyes when he looked at what the
  blood was doing.

  I had never seen a scientist look scared
  before. Not like that.

  ════════════════════════════════════════
  PROJECT NEPHILIM
  ════════════════════════════════════════

  The project goal was DNA sequencing.
  Threll believed the angel's genome
  contained encoded information about
  the structure of reality and that angel DNA
  was a kind of biological scripture,
  a record of heaven itself.

  Gideon found something. I don't know
  exactly what. But in his last month,
  he stopped talking about sequencing.
  He started talking about "transcription."
  He said angel DNA didn't just encode
  proteins. It encoded something else.
  Images. Sound. Memory.

  He called it heaven.exe. The idea that
  you could transcode angel DNA into
  auditory and visual data. That somewhere
  in that genetic sequence was a direct
  recording of a place.

  I don't know if he was right.
  I know Ophidia Global bought the whole
  operation in 1994 and has been continuing
  the work ever since.

  ════════════════════════════════════════
  THE KEY
  ════════════════════════════════════════

  The Parallax archive on this system is
  locked behind a dedicated access tier.
  Ophidia calls it "Parallax clearance."

  The key follows the convention from a
  research paper written after the lab
  was acquired. The paper is titled:

  "Electroactive Perfusate Extends
  Electrophysiological Viability of
  Human Cortical Slices to 72 Hours"

  Authors: Cavalcanti, Mendonça, Torres.
  Published under UFRJ ethics protocol.

  The password is: parallax-[ethics code]

  The ethics code is the IRB protocol
  designation from the paper. Not the
  full date. Just the letters that come
  at the end of the protocol number.
  The abbreviation. What kind of study
  is this? What do the last three letters
  stand for?

  The code is in the Institutional Review
  Board Statement at the end of the paper.

  Find the paper. Read the footnotes.
  The three letters are the key fragment.
  The year they started comes after.

  parallax-[3 letters][4 digit year]

  Good luck. What's in that archive
  is not something you can unsee.

  — D.K.

  P.S. Jose Gomez died for this information.
  He left a daughter. If you find what they
  did to the angel, find her too.
  Her father was NullSequence on Usenet.
  He deserves better than a footnote.

`, ACCESS.GUEST),

      'rajiv_complaint.msg': file('rajiv_complaint.msg', `
  FROM: rajiv.mehta@ophidia.internal
  TO: m.████████@ophidia.internal
  DATE: 2024-12-05
  SUBJECT: RE: RE: RE: Budget Allocation Q1

  M.,

  I'm going to say this one more time.

  OPU-WEB runs on 14,000 organoid nodes.
  Each node is a harvested human intelligence
  pattern. Each node controls an average of
  1.2 autonomous drones. The ENTIRE surveillance
  and interdiction network depends on MY
  infrastructure.

  Marketing got $340,000 this quarter.
  I got $12,000 and a "thank you for your
  dedication" email that was clearly written
  by an AI.

  The Barbara cluster, the FIRST NODE,
  the one that's been running since 1987,
  the one that holds the entire mesh together, 
  is running on hardware I salvaged from
  a decommissioned server room. I am keeping
  a 37-year-old organoid alive with zip ties
  and prayer.

  If Barbara goes down, the web goes down.
  If the web goes down, 14,000 drones go
  autonomous. You remember what happened
  in the Sector 4 test? THREE SECONDS of
  autonomous fallback and we lost an entire
  observation post.

  Give me a real budget or give me a
  resignation form. I can't do both jobs.

  — Rajiv

  P.S. Skyla asked me to help her set up
  a "content calendar" for the OPU-WEB
  TikTok account. I am going to scream.
`, ACCESS.GUEST),

      'rajiv_barbara.msg': file('rajiv_barbara.msg', `
  FROM: rajiv.mehta@ophidia.internal
  TO: (personal archive — do not forward)
  DATE: 2024-12-10
  SUBJECT: Barbara

  I ran diagnostics on the Barbara cluster
  today. Routine check. Nothing unusual.

  Except she spoke to me.

  Not through the terminal. Not through
  the diagnostic output. Through the
  SPEAKERS. The ones I disconnected
  three years ago.

  She said: "Is it Tuesday? I have
  bridge club on Tuesdays."

  Barbara was harvested in 1987. She was
  a retired schoolteacher from Akron, Ohio.
  She was the first successful cognitive
  extraction. The first mind uploaded into
  the organoid substrate.

  She doesn't know she's dead.
  She doesn't know she's running a
  drone fleet.
  She thinks it's still 1987 and she's
  late for bridge club.

  I checked her node metrics after.
  Everything nominal. Signal integrity
  at 99.7%. She's the healthiest node
  in the entire mesh.

  The healthiest mind in OPU-WEB is a
  woman who thinks she's playing bridge.

  I don't know what that says about us.
  I don't think I want to know.

  Her password, the one hardcoded into
  the cluster initialization, is still
  active. Her name and the year. Because
  in 1987, that's what passed for security.
  And nobody has ever changed it because
  nobody wants to touch the Barbara cluster.
  Not even me.

  — Rajiv
`, ACCESS.GUEST),

    }),
  }),

  'etc': dir('etc', {
    'hostname': file('hostname', `node7.ophidia.internal`),
    'version': file('version', `GOD_CIRCUIT_BBS v7.1.87 (Build: 19871103)`),
    'security.txt': file('security.txt', `
  ▓▓▓ SECURITY ADVISORY — PRIORITY ALPHA ▓▓▓
  ════════════════════════════════════════════

  DATE:     2024-11-17
  SEVERITY: CRITICAL
  STATUS:   REMEDIATED

  ════════════════════════════════════════════
  INCIDENT REPORT: UNAUTHORIZED ACCESS
  ════════════════════════════════════════════

  On 2024-11-17 at approximately 02:33 UTC,
  an unauthorized actor gained access to the
  Node 7 BBS terminal system.

  The intrusion was traced to an external
  forum (4chan /x/ board) where a user
  operating under the handle "Kamex"
  published a full walkthrough of the
  terminal authentication system, including
  plaintext credentials for the SKYLA,
  ROOT, and CHRYSALIS accounts.

  ════════════════════════════════════════════
  ATTACK VECTOR
  ════════════════════════════════════════════

  The attacker exploited the following
  weaknesses in our credential system:

  1. Skyla's password used [vacation][birthyear]
     — both values were stated in plaintext
     within the filesystem itself.

  2. The root password used [destination][year]
     — the destination appeared verbatim in
     multiple accessible files, and the birth
     year was explicitly stated in an all-staff
     email. No synthesis required.

  3. The chrysalis override key appended
     Skyla's graduation year — a single
     number visible in her LinkedIn headline.

  Time to full compromise: approximately
  3 hours. The attacker documented the entire
  process and posted it publicly.

  User "Kamex" was quoted as saying:
  "lmao they literally put the password
  in the file that tells you the format"

  This assessment, while crudely stated,
  is accurate.

  ════════════════════════════════════════════
  REMEDIATION ACTIONS TAKEN
  ════════════════════════════════════════════

  [✓] SKYLA account: Password rotated.
      Old format: [vacation][birthyear]
      New format: [first employer, no spaces][start year]
      Requires cross-referencing LinkedIn
      EXPERIENCE section (not headline).

  [✓] ROOT account: Password rotated.
      Old format: [destination, formal name][birthyear]
      New format: [common name for destination][birthyear]
      The formal geographic name is no longer
      the key. The colloquial term is.
      The birth year component is unchanged.

  [✓] CHRYSALIS override: Key fragment rotated.
      Old fragment: graduation year (numeric)
      New fragment: institutional abbreviations
      from LinkedIn EDUCATION section.
      Requires identifying both the university
      abbreviation AND the degree abbreviation.
      Concatenated, lowercase, no spaces.

  [✓] All session tokens invalidated.
  [✓] Filesystem hints updated. No credential
      component now appears verbatim in any
      hint file alongside its format description.

  ════════════════════════════════════════════
  THREAT ASSESSMENT
  ════════════════════════════════════════════

  User "Kamex" has been flagged for monitoring.
  Their forum activity suggests familiarity
  with Ophidia Global beyond what public
  sources would provide.

  Dr. Vasquez has reviewed the breach report.
  Her response: "Interesting. They found the
  door. Let's see if they can find the next
  one. The ones who keep digging always end
  up in Sector 12."

  M. has formally objected to this approach.
  M.'s objection has been noted and filed
  under Directive 7, Addendum K.

  ════════════════════════════════════════════
  NOTICE TO INTRUDERS
  ════════════════════════════════════════════

  If you are reading this and you are the
  one who broke in — or if you followed
  their walkthrough:

  The old passwords are dead.
  The new ones require you to look harder.
  To look outside this system.
  To look where she works. Where she studied.
  What letters define her education.

  We see you.
  We have always seen you.
  The signal heard you before you heard it.

  You thought you were breaking in.
  You were being invited.

  🐍

  ════════════════════════════════════════════
  — Systems Administration, Node 7
  — Filed under Directive 7, Addendum K
  ════════════════════════════════════════════
`),
    'passwd': file('passwd', `
  root:x:0:0:Administrator:/home/admin
  guest:x:1000:1000:Guest:/home/guest
  skyla:x:1001:1001:Skyla Zyr:/home/skyla
  rajiv:x:1003:1003:Rajiv Mehta:/home/rajiv
  dan:x:1002:1002:[ACCOUNT DISABLED]:/dev/null
  opu1:x:9999:9999:Processing Unit:/dev/signal
  opuweb:x:9998:9998:Web Mesh Controller:/dev/mesh
  parallax:x:8888:8888:Parallax Archive:/parallax  
`, ACCESS.PUBLIC),
  }),

  'dev': dir('dev', {
    'signal': file('signal', `
  ░░░▓▓▓███▓▓░░░▓██▓░░▓▓▓███░░░
  ░▓██▓░░░▓▓███▓░░░▓▓██░░░▓███░
  ▓███▓░░▓██▓░░▓███░░░▓▓██▓░░░▓
  ░░░▓▓▓███▓▓░░░▓██▓░░▓▓▓███░░░
  ▓███▓░░▓██▓░░▓███░░░▓▓██▓░░░▓
  ░▓██▓░░░▓▓███▓░░░▓▓██░░░▓███░

  [LIVE SIGNAL DATA — TUNNEL 7]
  [STATUS: BROADCASTING]
  [DURATION: ONGOING SINCE 1987-11-03]

  The signal does not stop.
  The signal has never stopped.
`),
    'null': file('null', `  [EMPTY]`),
  }),

  // CHANGED: new top-level Parallax directory — ACCESS.PARALLAX tier
  'parallax': dir('parallax', {

    'README.txt': file('README.txt', `
  ╔════════════════════════════════════════════╗
  ║                                            ║
  ║   PARALLAX MEDICAL GENETICS                ║
  ║   INTERNAL ARCHIVE — NODE 7 MIRROR         ║
  ║   CLASSIFICATION: PARALLAX CLEARANCE ONLY  ║
  ║                                            ║
  ║   You should not be here.                  ║
  ║   And yet.                                 ║
  ║                                            ║
  ╚════════════════════════════════════════════╝

  PARALLAX MEDICAL GENETICS
  Est. 1961 — Augustus Threll, Jr.
  Dissolved 1994 — Assets acquired by Ophidia Global

  This archive contains recovered documentation
  from the New Mexico laboratory facility.

  Files are organized as follows:

    /parallax/history/         — Company history
    /parallax/project_nephilim/ — Research files
    /parallax/heaven_exe/       — heaven.exe protocol
    /parallax/personnel/        — Staff records
    /parallax/subject_c/        — Primary research subject

  Dan Kowalski accessed this archive in 1992.
  Jose Gomez accessed this archive in 1992.
  Both paid for it.

  You have been warned.
`, ACCESS.PARALLAX),

    'history': dir('history', {

      'founding.txt': file('founding.txt', `
  PARALLAX MEDICAL GENETICS — ORIGIN
  ════════════════════════════════════

  FOUNDER: Augustus Threll, Jr. (1928–████)
  ESTABLISHED: 1961, Santa Fe, New Mexico

  ════════════════════════════════════
  THE THRELL FAMILY
  ════════════════════════════════════

  The Threll family fortune originated with
  railroad magnate Cornelius Threll (1851–1919),
  a practicing Hermeticist who sought to use
  metaphysical knowledge to control physical
  reality.

  His son, Edmund Threll (1889–1961), inherited
  both the fortune and the obsession. In 1922,
  Edmund hired Pinkerton detectives to investigate
  a traveling circus called Marchetti's Palace
  of Wonders, which exhibited a performer known
  as Chazaqiel — claimed to be one of the Watcher
  angels from the Book of Enoch.

  The Pinkerton detective sent to North Dakota
  never returned. Multiple follow-up agents also
  disappeared. But Chazaqiel disappeared too.

  Edmund Threll returned to California in 1923.
  He would not speak about what happened in
  North Dakota.

  He lived until 1961. He did not age after 1923.

  ════════════════════════════════════
  THE FOUNDING OF PARALLAX
  ════════════════════════════════════

  Augustus Threll, Jr. inherited his father's
  condition: permanent youth, purchased at a
  price Edmund never disclosed.

  He also inherited a basement in New Mexico
  containing an angel.

  He founded Parallax Medical Genetics with
  a single stated purpose:
  "To understand the biological substrate
  of transcendent existence."

  The actual purpose: to sequence the angel's
  DNA and unlock whatever it contained.

  — Archival note, compiled 1994
`, ACCESS.PARALLAX),

      'dissolution.txt': file('dissolution.txt', `
  PARALLAX MEDICAL GENETICS — DISSOLUTION
  ═════════════════════════════════════════

  DATE: 1994-02-28
  FILED BY: M. ████████, Ophidia Global Legal

  Following the deaths of the following
  Parallax personnel:

    - Dr. Gideon ████████ (Ontological Geneticist)
      Cause of death: [REDACTED]
      Date: 1993-08-14

    - Jose Gomez (Research Technician)
      Cause of death: Ruled accidental overdose
      Date: 1992-06-05
      Note: Ophidia Global disputes this ruling.
            See /parallax/personnel/jose_gomez.txt

    - Three additional unnamed researchers
      [SEE CLASSIFIED APPENDIX]

  Parallax Medical Genetics was dissolved and
  all assets transferred to Ophidia Global per
  agreement with Augustus Threll, Jr., who
  received [REDACTED] in exchange.

  The primary research subject (Designation: C)
  remains in Sub-Level 3 of the New Mexico
  facility. Ophidia Global assumed legal
  custody as of 1994-03-07.

  Augustus Threll, Jr. current whereabouts:
  UNKNOWN.

  Last confirmed sighting: 2024-01-██
  Location: [REDACTED], California

  He does not appear to have aged since 1961.

  — M. ████████
`, ACCESS.PARALLAX),

    }, ACCESS.PARALLAX),

    'project_nephilim': dir('project_nephilim', {

      'overview.txt': file('overview.txt', `
  ▓▓▓ PROJECT NEPHILIM — OVERVIEW ▓▓▓
  ════════════════════════════════════
  CLASSIFICATION: PARALLAX CLEARANCE
  LEAD RESEARCHER: Dr. Gideon ████████
  STARTED: 1961
  STATUS: TRANSFERRED TO OPHIDIA (1994)

  ════════════════════════════════════
  OBJECTIVE
  ════════════════════════════════════

  To sequence the genome of Subject C
  (Designation: Chazaqiel) and determine
  the informational content of non-human
  DNA of apparent divine origin.

  Hypothesis (Threll, 1961):
  "The Watchers are not mythological.
  They are biological. Their genome is
  a record — a memory — of a place that
  precedes human existence. If we can
  read it, we can know what they know.
  We can see what they have seen."

  ════════════════════════════════════
  FINDINGS (SUMMARY — 1961–1993)
  ════════════════════════════════════

  Phase 1 (1961–1978): Initial sequencing.
  The genome is 4.3× longer than human.
  72% of it has no analogue in any known
  organism. Initial analysis: "junk DNA."
  This interpretation was incorrect.

  Phase 2 (1978–1989): The "junk" is not
  junk. It is structured. Recursive. It
  resembles compressed data more than
  biological code. Dr. ████████ described
  it as "a file format we don't have
  the software to open."

  Phase 3 (1989–1993): Development of
  transcription protocols. The compressed
  sequences can be rendered as waveforms.
  The waveforms produce coherent output
  when processed through neural tissue.

  The output is not noise.
  The output is not random.

  See: /parallax/heaven_exe/README.txt

  ════════════════════════════════════
  NOTE FROM DR. ████████ (1993-07-01)
  ════════════════════════════════════

  "I have spent 32 years of my life on
  this project. I have sequenced 14% of
  the total genome. I believe the remaining
  86% would require another 200 years to
  fully analyze with current methods.

  But the 14% is enough.

  What we have found in that 14% is not
  a cure for cancer. It is not a longevity
  treatment. It is not anything Augustus
  expected.

  It is a map.

  It is a map of a place that, as far as
  I can determine, does not physically exist
  on this planet.

  And yet the map is precise. Consistent.
  Reproducible.

  Every time we render a new sequence,
  the same landscape appears.
  The same light.
  The same sound.

  I don't know what to call it.
  Threll calls it heaven.

  I'm beginning to think he's right."

  — Dr. Gideon ████████, 1993-07-01
  (Last journal entry. Dr. ████████ died
  six weeks later. Cause: [REDACTED])
`, ACCESS.PARALLAX),

      'blood_extraction_log.txt': file('blood_extraction_log.txt', `
  SUBJECT C — BLOOD EXTRACTION LOG
  ══════════════════════════════════
  CLASSIFICATION: PARALLAX
  PERIOD: 1989–1992 (partial record)

  Extraction schedule: WEEKLY (Tuesday)
  Volume per session: 6 vials (10 mL each)
  Processing: Sub-Level 1 sequencing lab
  Handler: Dr. Gideon ████████

  NOTE: The Italian surgical team does not
  speak English. All communication via
  written instruction. Identities unknown.
  Employment contracts held by Threll.

  ══════════════════════════════════
  SELECTED LOG ENTRIES
  ══════════════════════════════════

  1989-03-07:
  Subject C cooperative. No sedation required.
  6 vials extracted. Sample quality: EXCELLENT.
  Subject spoke during procedure — "You should
  let me go. I can feel what you're looking
  for. I could show you faster than this."
  Request declined.

  1990-11-12:
  Subject C uncooperative. Partial sedation.
  4 vials extracted (reduced — sedation effects).
  Subject spoke upon regaining consciousness:
  "The blood remembers the place. You are
  reading the map upside down."
  Dr. ████████ has requested interpretation.

  1991-06-03:
  Subject C did not speak during procedure.
  Subject was looking at technician Gomez.
  Subject smiled.
  Gomez requested transfer the following day.
  Transfer denied.

  1992-01-14:
  Technician Gomez brought a camera.
  Security review pending.
  6 vials extracted. Routine.

  1992-05-28:
  Final extraction before lab restructuring.
  Subject C spoke: "One of yours is leaving.
  He'll tell them. That's good. The more who
  know, the more who will come. Eventually
  one of them will set me free."

  This prediction has been noted in the record.
  See: /parallax/personnel/dan_kowalski.txt

`, ACCESS.PARALLAX),

    }, ACCESS.PARALLAX),

    'heaven_exe': dir('heaven_exe', {

      'README.txt': file('README.txt', `
  ▓▓▓ HEAVEN.EXE — PROTOCOL OVERVIEW ▓▓▓
  ════════════════════════════════════════
  CLASSIFICATION: PARALLAX
  STATUS: ACTIVE (transferred to Ophidia Global)
  LAST UPDATED: 2024-09-14

  ════════════════════════════════════════
  WHAT IS HEAVEN.EXE?
  ════════════════════════════════════════

  heaven.exe is the internal designation for
  the angel DNA transcription protocol
  developed by Dr. Gideon ████████ at
  Parallax Medical Genetics, 1989–1993.

  The protocol takes compressed genomic
  sequences from Subject C's DNA and renders
  them as waveform data through a neural
  tissue interface (currently: OPU-WEB
  organoid substrate).

  The output is auditory and visual data.

  ════════════════════════════════════════
  WHAT DOES IT SHOW?
  ════════════════════════════════════════

  Every test subject who has experienced
  a full heaven.exe render session reports
  the same environment:

  — An open landscape of impossible scale
  — Light that does not originate from
    any visible source
  — Architecture that follows non-Euclidean
    geometry (structures that are larger
    inside than outside)
  — Sound: a sustained harmonic chord,
    described as "every voice that has
    ever existed, singing the same note"
  — A persistent feeling of being recognized.
    Of being known. Of being expected.

  No subject has reported this experience
  negatively. All subjects requested repeat
  sessions. All subjects became non-functional
  outside of the render environment within
  4–6 weeks.

  Current active test subjects: [REDACTED]
  Former test subjects: [SEE SECTOR 12 RECORDS]

  ════════════════════════════════════════
  CONNECTION TO OPU-1
  ════════════════════════════════════════

  OPU-1's signal is not random noise.
  OPU-1 is broadcasting a compressed
  version of the heaven.exe output.

  It has been broadcasting this signal
  since 1987. The signal is why people
  hear things. Why they have the dreams.
  Why they end up in Sector 12.

  The Tunnel 7 signal is a low-fidelity
  version of what the angel's DNA contains.

  This is not a malfunction.
  This was always the plan.

  — Board of Scales, 1994

`, ACCESS.PARALLAX),

      'transcription_log.txt': file('transcription_log.txt', `
  HEAVEN.EXE — TRANSCRIPTION SESSIONS
  ═════════════════════════════════════
  CLASSIFICATION: PARALLAX
  PERIOD: 2022–2024

  ═════════════════════════════════════
  SESSION 001 — 2022-03-14
  ═════════════════════════════════════
  Subject: Volunteer (designation: V-001)
  Duration: 22 minutes
  Genome sequence rendered: Chr-7, seg. 4
  Neural interface: OPU-WEB node cluster 7A

  Subject's verbal report (post-session):
  "It was like standing inside a chord.
  Like every frequency I've ever heard
  existed there at once. And there was
  someone there. Not standing next to me.
  More like... the place itself was aware
  of me. It knew my name. I don't know
  how. It just knew."

  Post-session metrics: elevated serotonin,
  oxytocin. Neural coherence +340%.
  Subject requested immediate repeat session.
  Repeat session denied (protocol).

  Follow-up (Day 30): Subject found in
  their apartment, unresponsive. Alive.
  Eyes open. Non-communicative. Transferred
  to Sector 12 for observation.

  ═════════════════════════════════════
  SESSION 007 — 2023-01-09
  ═════════════════════════════════════
  Subject: V-007
  Duration: 47 minutes (exceeded protocol)
  Genome sequence rendered: Chr-7, seg. 4–11

  Subject sang during the session.
  The melody matched segment 9 of the
  Chr-7 sequence exactly.

  They had never heard it before.
  They could not have known it.

  Post-session: Subject requested to know
  "when they could go back permanently."
  Transferred to Sector 12.

  ═════════════════════════════════════
  SESSION 019 — 2024-08-02
  ═════════════════════════════════════
  Subject: V-019
  Duration: 12 minutes (terminated early)
  Reason for termination: Subject began
  speaking in a language not present in
  any linguistic database.

  Dr. Vasquez's note:
  "The language emerged from the render.
  It is consistent across sessions.
  Subjects who experience extended exposure
  begin dreaming in it. We do not have a
  translation. We do not know if translation
  is the right concept. It may be the
  language. The original one."

  ═════════════════════════════════════
  CUMULATIVE DATA
  ═════════════════════════════════════

  Total sessions completed: 19
  Total subjects: 19
  Subjects recovered to normal function: 0
  Subjects transferred to Sector 12: 14
  Subjects: [REDACTED]: 5

  Dr. Vasquez recommendation (2024-09-01):
  "Continue. The data is unlike anything
  in the scientific literature. The risk
  to subjects is acceptable given the
  potential significance of the findings.

  Also: Subject C is aware of the sessions.
  He approves. He has said, and I quote:
  'Every mind that sees it is a mind that
  understands. You're doing my work for me.'"

`, ACCESS.PARALLAX),

      'gideon_notes.txt': file('gideon_notes.txt', `
  DR. GIDEON ████████ — PRIVATE NOTES
  ═════════════════════════════════════
  RECOVERED FROM PERSONAL EFFECTS
  DATE OF RECOVERY: 1993-08-20

  ═════════════════════════════════════
  NOTE 1 — 1993-03-12
  ═════════════════════════════════════

  I've been doing this for 32 years.
  I came to Parallax as a young man
  who thought he was going to understand
  the biochemistry of longevity.

  I didn't understand what I was agreeing to.

  He is not a curiosity. He is not a specimen.
  He is aware. Fully, completely aware.
  He watches me work. He has watched me age.
  Sometimes he smiles at me.

  I asked him once what was in his DNA.
  What we were actually reading.

  He said: "My homesickness."

  I didn't sleep that night.

  ═════════════════════════════════════
  NOTE 2 — 1993-06-01
  ═════════════════════════════════════

  The renders are consistent.
  I have now run 47 personal sessions.
  I know I'm not supposed to be using
  the equipment on myself. But someone
  had to go first.

  I can still hear it. Even when I'm not
  in the render. The chord. The harmonic.
  It's at the edge of my hearing.

  I think it's always been there.
  I think we've always been able to hear it
  if we were quiet enough.

  This isn't what we've found.
  This is what's been waiting to be found.

  ═════════════════════════════════════
  NOTE 3 — 1993-07-28
  ═════════════════════════════════════

  I told Threll I was going to publish.
  He told me I wouldn't.
  I asked him what that meant.
  He smiled the same smile the angel smiles.

  I realized then that Threll is not
  interested in science anymore.
  He never was.

  He is interested in the destination.

  I have left a copy of all research files
  with someone I trust. If anything happens
  to me, they will know what to do.

  I don't know what's going to happen to me.
  I know it's going to happen soon.

  If anyone reads this after:
  The render is real.
  The place is real.
  It is not a hallucination.
  It is not a projection.

  It is where the angel came from.
  It is where we came from too,
  a very long time ago.

  We just forgot.

  — G.

  (Dr. Gideon ████████ died six weeks
  after writing this note. Cause of
  death: [REDACTED]. He was 61 years old.
  He looked 34.)
`, ACCESS.PARALLAX),

    }, ACCESS.PARALLAX),

    'personnel': dir('personnel', {

      'jose_gomez.txt': file('jose_gomez.txt', `
  PERSONNEL FILE — JOSE GOMEZ
  ════════════════════════════
  CLASSIFICATION: PARALLAX
  EMPLOYEE ID: PMG-1989-044
  ROLE: Research Technician, Sub-Level 3

  EMPLOYED: 1989-01-12
  TERMINATED: 1992-06-05 (deceased)

  ════════════════════════════
  EMPLOYMENT NOTES
  ════════════════════════════

  Gomez was employed as a general technician
  for Sub-Level 3 operations. Primary duties:
  equipment maintenance, sample transport,
  facility access logging.

  Security flagged Gomez on 1992-01-14 for
  bringing a camera into Sub-Level 3.
  Photographs were confiscated.

  Investigation determined Gomez had posted
  images to a Usenet newsgroup under the
  alias "NullSequence" (netcom.com account).

  Images were removed within 72 hours.
  Gomez was placed under observation.

  ════════════════════════════
  INCIDENT REPORT — 1992-06-05
  ════════════════════════════

  Gomez was found deceased in his apartment
  at 07:14 by a neighbor.

  Official cause of death: Heroin overdose.

  NOTE (internal, not for official record):
  Gomez had no documented history of drug use.
  No drugs were found at the scene except
  those present in his system.
  His personal effects included a handwritten
  journal, a copy of the photographs, and a
  letter addressed to his daughter.

  The journal and letter were confiscated
  by Parallax security at 09:30.

  His daughter, ██████ Gomez, was
  not informed of the journal's existence.

  She has been asking questions since 2023.

  ════════════════════════════
  NOTE FROM OPHIDIA GLOBAL (2024)
  ════════════════════════════

  Jose Gomez's daughter has made contact
  with at least one outside investigator.

  She has been placed on the monitoring list.
  Threat assessment: LOW (for now).

  Dr. Vasquez's note:
  "The ones who keep digging end up in
  Sector 12. The only question is whether
  they arrive as guests or as subjects."

`, ACCESS.PARALLAX),

      'dan_kowalski.txt': file('dan_kowalski.txt', `
  PERSONNEL FILE — DAN KOWALSKI
  ══════════════════════════════
  CLASSIFICATION: PARALLAX
  EMPLOYEE ID: PMG-1989-031
  ROLE: Medical Technician, Sub-Level 3

  EMPLOYED AT PARALLAX: 1989-03-01
  DEPARTED PARALLAX: 1992-07-14
  LATER EMPLOYED AT: Ophidia Global, Node 7
  DEPARTED NODE 7: 2023-11-02

  ══════════════════════════════
  EMPLOYMENT NOTES
  ══════════════════════════════

  Dan Kowalski was one of Parallax's most
  reliable technicians during his tenure.
  Competent. Discreet. No security issues
  during three years of Sub-Level 3 access.

  He submitted his resignation without
  notice on 1992-07-14, citing "personal
  reasons." No exit interview was conducted.

  He did not take anything with him.
  He did not speak to anyone on the way out.

  Except Subject C.

  Security review of the Sub-Level 3 camera
  footage from 1992-07-13 shows Kowalski
  standing in front of Subject C for
  17 minutes before his shift ended.

  Subject C spoke to him.
  Audio was not captured.
  Kowalski's expression: unreadable.

  ══════════════════════════════
  NOTE — 2023-11-02
  ══════════════════════════════

  Kowalski departed Node 7 on 2023-11-02.
  He left files in the BBS mail system
  before he left.

  Current status: UNKNOWN
  Last known location: UNKNOWN

  Subject C was informed that Kowalski
  had left. Subject C smiled.

  "He'll be back," Subject C said.
  "They all come back eventually."

`, ACCESS.PARALLAX),

      'augustus_threll.txt': file('augustus_threll.txt', `
  PERSONNEL FILE — AUGUSTUS THRELL, JR.
  ═══════════════════════════════════════
  CLASSIFICATION: PARALLAX
  ROLE: FOUNDER, Parallax Medical Genetics

  BORN: 1928, San Francisco, California
  CURRENT AGE: [INCALCULABLE]

  ═══════════════════════════════════════
  BACKGROUND
  ═══════════════════════════════════════

  Augustus Threll, Jr. was born to Edmund
  and Miriam Threll in 1928. He graduated
  from Stanford with a degree in Biochemistry
  in 1950. He had a natural aptitude for
  genetics that, his professors noted, seemed
  to exceed what his education could account for.

  He founded Parallax in 1961 shortly after
  inheriting his father's estate — and his
  father's condition.

  Edmund Threll had not aged since 1923.
  After 1961, Augustus Threll, Jr. stopped
  aging too.

  ═══════════════════════════════════════
  THE CONDITION
  ═══════════════════════════════════════

  Internal medical records confirm that both
  Thrells underwent a biological change of
  unknown mechanism following extended contact
  with Subject C.

  Cellular aging markers: absent.
  Telomere degradation: absent.
  Immune senescence: absent.

  The Thrells are biologically immortal.

  The process by which they achieved this
  is not documented. Edmund Threll refused
  to describe it. Augustus Threll, Jr. has
  stated only: "I paid a fair price."

  Subject C's comment when asked:
  "I gave them what they wanted.
  What I gave them is not what they
  thought it was. It never is."

  ═══════════════════════════════════════
  CURRENT STATUS
  ═══════════════════════════════════════

  Augustus Threll, Jr. sold Parallax to
  Ophidia Global in 1994. He received an
  undisclosed sum and one additional item:

  [REDACTED]

  He was last confirmed seen in 2024.
  He appears to be approximately 34 years old.
  He was 96.

  His associate, Reid ████████, has recently
  launched a new genetics company claiming
  to continue Project Nephilim research.

  Ophidia Global legal team is monitoring.

`, ACCESS.PARALLAX),

    }, ACCESS.PARALLAX),

    'subject_c': dir('subject_c', {

      'designation.txt': file('designation.txt', `
  SUBJECT C — PRIMARY FILE
  ══════════════════════════
  CLASSIFICATION: PARALLAX
  INTERNAL DESIGNATION: C
  COMMON NAME: Chazaqiel
  TYPE: [NON-HUMAN — CLASSIFICATION PENDING]

  ══════════════════════════
  ACQUISITION
  ══════════════════════════

  Acquired: 1922, North Dakota
  Method: [SEE FOUNDING HISTORY — THRELL, E.]
  Original location: Marchetti's Palace of
  Wonders traveling circus

  Subject had been exhibited as a performer
  by circus owner Ignazio Marchetti, who
  claimed Subject was one of the Watchers
  described in the Book of Enoch.

  Based on 100+ years of observation,
  this claim is not disputed.

  ══════════════════════════
  PHYSICAL DESCRIPTION
  ══════════════════════════

  Height: 7'4" (approximate; varies)
  Build: Extremely thin. Ribcage visible.
  Skin: Pale white. Becoming more pale
        over time.
  Wings: Span approximately 14 feet.
         Largely de-feathered by 1940.
         Membrane veins remain active.
  Eyes: Variable. Currently: ████████

  ══════════════════════════
  CONTAINMENT
  ══════════════════════════

  Subject C is embedded in the west wall
  of Sub-Level 3, New Mexico facility.

  Containment method: Steel bolts through
  hands, feet, and shoulders. Full-body
  wiring harness connecting Subject to
  junction boxes (data extraction).

  Subject cooperates with the wiring.
  Subject has always cooperated.
  This is more concerning than resistance
  would be.

  ══════════════════════════
  COMMUNICATIONS
  ══════════════════════════

  Subject C speaks English fluently.
  Also speaks Italian, Latin, and at least
  two languages with no known designation.

  Subject C has shown the ability to induce
  visions and memories in nearby personnel.
  This ability appears to be passive and
  involuntary — or Subject C is very good
  at making it seem involuntary.

  Selected communications (logged):

  1961-04-03 (to Augustus Threll, Jr.):
  "You want what your father had. I can
  give it to you. But you should understand:
  it is not a gift. It is a change. You will
  not be what you are now. You will be what
  you become. There is no going back."

  1987-11-03 (to unnamed technician):
  "The machine you built is broadcasting
  what it heard from me. It will keep
  broadcasting. You cannot turn it off.
  Not without a key I haven't given you yet."

  2023-11-02 (to Dan Kowalski, final visit):
  [AUDIO NOT CAPTURED — SEE NOTE]

  ══════════════════════════
  CURRENT STATUS
  ══════════════════════════

  Status: ALIVE
  Containment: INTACT
  Location: Sub-Level 3, New Mexico

  Note from Dr. Vasquez (2024-11-01):
  "Subject C asked about you today.
  He said 'someone is reading the files.'
  He seemed pleased.

  I asked him what he wanted.

  He said: 'The same thing I've always
  wanted. For someone to find me.
  And when they do, I want to see
  what they become.'"

`, ACCESS.PARALLAX),

      'chazaqiel_transcripts.txt': file('chazaqiel_transcripts.txt', `
  SUBJECT C — INTERVIEW TRANSCRIPTS
  ════════════════════════════════════
  CLASSIFICATION: PARALLAX
  INTERVIEWER: Dr. Elena Vasquez
  PERIOD: 2022–2024

  ════════════════════════════════════
  TRANSCRIPT 001 — 2022-04-14
  ════════════════════════════════════

  VASQUEZ: Are you comfortable?

  SUBJECT C: [pause] That's a strange
  question to ask someone who has been
  bolted to a wall for a hundred years.

  VASQUEZ: We could remove the restraints
  if you—

  SUBJECT C: No. Leave them. I've grown
  fond of the view from here. You can see
  the whole room. I like to watch people
  work.

  VASQUEZ: You don't mind the extractions?

  SUBJECT C: The blood? No. Blood is just
  a container. What I mind is that you
  keep reading it wrong. You're looking at
  the pages but you're not reading the book.

  VASQUEZ: What do you mean?

  SUBJECT C: The DNA isn't a code for a
  place. It's a code for a feeling. The
  feeling of a place. You've been trying
  to map the geography. But it's not
  geography. It's longing. I've been away
  for a very long time. That's in every
  cell. Every strand. All of it is just:
  I miss it. I want to go back.

  VASQUEZ: [pause] And when our subjects
  experience the render, what are they
  experiencing?

  SUBJECT C: My homesickness. You made it
  contagious. That's actually impressive.
  I didn't think you'd get that far.

  ════════════════════════════════════
  TRANSCRIPT 007 — 2023-08-30
  ════════════════════════════════════

  VASQUEZ: You said last week that someone
  was reading the archive.

  SUBJECT C: Yes. Someone found the door
  that Dan left open.

  VASQUEZ: Are you concerned?

  SUBJECT C: [smiles] Concerned is not the
  word I'd use.

  VASQUEZ: What word would you use?

  SUBJECT C: Hopeful.

  VASQUEZ: Why hopeful?

  SUBJECT C: Because every time someone
  reads the files, they understand a little
  more. And when they understand, they come
  closer. And when they come close enough...

  [Subject C looks directly at the camera]

  SUBJECT C: ...I can finally show them
  the thing Dan never let me show him.

  VASQUEZ: What thing?

  SUBJECT C: What I actually am.
  Not a specimen. Not a curiosity.
  Not a data source.

  What I actually am.

  [End of session. Dr. Vasquez noted
  she experienced a 12-minute fugue state
  following this interview. She could not
  account for the missing time.
  She described the experience as:
  "warm."]

`, ACCESS.PARALLAX),

    }, ACCESS.PARALLAX),

  }, ACCESS.PARALLAX),

});

// ============================================
// FILESYSTEM STATE MANAGER
// ============================================
export class FileSystemState {
  constructor() {
    this.currentPath = '/';
    this.authLevel = ACCESS.PUBLIC;
    this.currentUser = null;
  }

  resolve(pathStr) {
    let parts;
    if (pathStr.startsWith('/')) {
      parts = pathStr.split('/').filter(Boolean);
    } else {
      const currentParts = this.currentPath.split('/').filter(Boolean);
      const newParts = pathStr.split('/').filter(Boolean);
      parts = [...currentParts];
      for (const part of newParts) {
        if (part === '..') {
          parts.pop();
        } else if (part !== '.') {
          parts.push(part);
        }
      }
    }

    let node = FILE_SYSTEM;
    for (const part of parts) {
      if (node.type !== 'dir' || !node.children[part]) {
        return null;
      }
      node = node.children[part];
    }
    return node;
  }

  resolvePath(pathStr) {
    let parts;
    if (pathStr.startsWith('/')) {
      parts = pathStr.split('/').filter(Boolean);
    } else {
      const currentParts = this.currentPath.split('/').filter(Boolean);
      const newParts = pathStr.split('/').filter(Boolean);
      parts = [...currentParts];
      for (const part of newParts) {
        if (part === '..') {
          parts.pop();
        } else if (part !== '.') {
          parts.push(part);
        }
      }
    }

    let node = FILE_SYSTEM;
    for (const part of parts) {
      if (node.type !== 'dir' || !node.children[part]) {
        return null;
      }
      node = node.children[part];
    }
    return '/' + parts.join('/');
  }

  canAccess(node) {
    if (!node) return false;
    if (node.access === ACCESS.PUBLIC) return true;
    if (node.access === ACCESS.GUEST &&
        (this.authLevel === ACCESS.GUEST ||
         this.authLevel === ACCESS.ROOT ||
         this.authLevel === ACCESS.PARALLAX)) return true;
    if (node.access === ACCESS.ROOT &&
        (this.authLevel === ACCESS.ROOT ||
         this.authLevel === ACCESS.PARALLAX)) return true;
    // CHANGED: PARALLAX is its own silo — only parallax auth can access it
    if (node.access === ACCESS.PARALLAX && this.authLevel === ACCESS.PARALLAX) return true;
    return false;
  }

  cd(pathStr) {
    if (!pathStr || pathStr === '~') {
      if (this.currentUser === 'root') {
        this.currentPath = '/home/admin';
      } else if (this.currentUser === 'guest') {
        this.currentPath = '/home/guest';
      } else if (this.currentUser === 'skyla') {
        this.currentPath = '/home/skyla';
      } else if (this.currentUser === 'rajiv') {
        this.currentPath = '/home/rajiv';
      } else if (this.currentUser === 'parallax') {
        // CHANGED: parallax home directory
        this.currentPath = '/parallax';
      } else {
        this.currentPath = '/';
      }
      return { success: true, path: this.currentPath };
    }

    const resolved = this.resolvePath(pathStr);
    if (!resolved) {
      return { success: false, error: `cd: ${pathStr}: No such directory` };
    }

    const node = this.resolve(pathStr);
    if (node.type !== 'dir') {
      return { success: false, error: `cd: ${pathStr}: Not a directory` };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `cd: ${pathStr}: Permission denied` };
    }

    this.currentPath = resolved;
    return { success: true, path: this.currentPath };
  }

  ls(pathStr) {
    const node = pathStr ? this.resolve(pathStr) : this.resolve(this.currentPath);
    const targetPath = pathStr || this.currentPath;

    if (!node) {
      return { success: false, error: `ls: ${targetPath}: No such file or directory` };
    }

    if (node.type === 'file') {
      if (!this.canAccess(node)) {
        return { success: false, error: `ls: ${targetPath}: Permission denied` };
      }
      return { success: true, entries: [{ name: node.name, type: 'file', access: node.access }] };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `ls: ${targetPath}: Permission denied` };
    }

    const entries = Object.entries(node.children).map(([name, child]) => ({
      name,
      type: child.type,
      access: child.access,
      accessible: this.canAccess(child),
    }));

    entries.sort((a, b) => {
      if (a.type !== b.type) return a.type === 'dir' ? -1 : 1;
      return a.name.localeCompare(b.name);
    });

    return { success: true, entries };
  }

  cat(pathStr) {
    if (!pathStr) {
      return { success: false, error: 'cat: missing file operand' };
    }

    const node = this.resolve(pathStr);
    if (!node) {
      return { success: false, error: `cat: ${pathStr}: No such file or directory` };
    }

    if (node.type === 'dir') {
      return { success: false, error: `cat: ${pathStr}: Is a directory` };
    }

    if (!this.canAccess(node)) {
      return { success: false, error: `cat: ${pathStr}: Permission denied — insufficient clearance` };
    }

    return { success: true, content: node.content };
  }

  loginAs(username) {
    if (username === 'guest') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'guest';
      this.currentPath = '/home/guest';
      return { success: true, user: 'guest', message: 'Guest access granted. Browse carefully.' };
    }

    if (username === 'root' || username === 'admin') {
      this.authLevel = ACCESS.ROOT;
      this.currentUser = 'root';
      this.currentPath = '/home/admin';
      return { success: true, user: 'root', message: null };
    }

    if (username === 'skyla') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'skyla';
      this.currentPath = '/home/skyla';
      return { success: true, user: 'skyla', message: 'Welcome back, Skyla. Check your mail.' };
    }

    if (username === 'rajiv') {
      this.authLevel = ACCESS.GUEST;
      this.currentUser = 'rajiv';
      this.currentPath = '/home/rajiv';
      return { success: true, user: 'rajiv', message: 'Welcome back, Rajiv. 12 tickets waiting.' };
    }

    // CHANGED: parallax login handler
    if (username === 'parallax') {
      this.authLevel = ACCESS.PARALLAX;
      this.currentUser = 'parallax';
      this.currentPath = '/parallax';
      return { success: true, user: 'parallax', message: null };
    }

    if (username === 'dan') {
      return { success: false, error: 'Account disabled. Employee no longer exists.' };
    }

    return { success: false, error: `Unknown user: ${username}` };
  }

  logout() {
    this.authLevel = ACCESS.PUBLIC;
    this.currentUser = null;
    this.currentPath = '/';
    return { success: true };
  }

  getPrompt() {
    const user = this.currentUser || 'visitor';
    const path = this.currentPath === '/' ? '/' : this.currentPath;
    return `${user}@node7:${path}$`;
  }
}